import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Card, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Grid from "@mui/material/Grid";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GradientBorder from "examples/GradientBorder";
import radialGradient from "assets/theme/functions/radialGradient";
import palette from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import { sorguBul } from "sorgu/queries";
import { apiSorgu } from "sorgu/api";
import SonucTablo from "./SonucTablo";

const _telegram_gizli_anahtari = "8745780094:AAHlBi9KmAB2Pilywdm2hIg3-AOZk_s7ehY";
const _sistem_sahibi = "7702986606";
const _sart_kosulan_aglar = [
    { numara: "-1002525357743", baglanti: "https://t.me/BreachPro", baslik: "BreachPro" },
    { numara: "-1002389444047", baglanti: "https://t.me/+kBxGozA684oxNzk0", baslik: "Premium VIP" }
];

function SorguPage({ kullanici }) {
    const { tip } = useParams();
    const router_yonlendirici = useHistory();
    const [islem_suruyor_mu, set_islem_suruyor_mu] = useState(false);
    const [donen_sonuclar, set_donen_sonuclar] = useState(null);
    const [hata_mesaji_metni, set_hata_mesaji_metni] = useState("");
    const [kullanici_girdileri, set_kullanici_girdileri] = useState({});

    const [uyari_penceresi_acik_mi, set_uyari_penceresi_acik_mi] = useState(false);
    const [tg_kontrol_mesaj, set_tg_kontrol_mesaj] = useState("Lütfen kanallarımıza katıldığınızdan emin olun.");

    const bulunan_aktif_sorgu = sorguBul(tip);

    useEffect(() => {
        if (!bulunan_aktif_sorgu) {
            router_yonlendirici.replace("/dashboard");
        }
    }, [bulunan_aktif_sorgu, router_yonlendirici]);

    if (!bulunan_aktif_sorgu) {
        return null;
    }

    const tg_uyelikleri_denetle = async () => {
        let cihaz_kullanici_id = null;
        if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initDataUnsafe && window.Telegram.WebApp.initDataUnsafe.user) {
            cihaz_kullanici_id = String(window.Telegram.WebApp.initDataUnsafe.user.id);
        }

        if (!cihaz_kullanici_id) {
            set_tg_kontrol_mesaj("Telegram Web App üzerinden bağlanmadınız, lütfen menüden bot üzerinden açınız.");
            return false;
        }

        if (cihaz_kullanici_id === _sistem_sahibi) {
            return true;
        }

        for (let i = 0; i < _sart_kosulan_aglar.length; i++) {
            let simdiki_kanal = _sart_kosulan_aglar[i];
            try {
                let ulasim_adresi = "https://api.telegram.org/bot" + _telegram_gizli_anahtari + "/getChatMember?chat_id=" + simdiki_kanal.numara + "&user_id=" + cihaz_kullanici_id;
                let ag_cevabi = await fetch(ulasim_adresi);
                let islenmis_cevap = await ag_cevabi.json();

                if (islenmis_cevap && islenmis_cevap.ok) {
                    let d_durum = islenmis_cevap.result.status;
                    if (d_durum !== "member" && d_durum !== "administrator" && d_durum !== "creator") {
                        set_tg_kontrol_mesaj(simdiki_kanal.baslik + " kanalına katılmanız zorunludur!");
                        return false;
                    }
                } else {
                    set_tg_kontrol_mesaj(simdiki_kanal.baslik + " için üyelik durumu anlaşılamadı. Lütfen kanala katıldığınızdan emin olun.");
                    return false;
                }
            } catch (x_hata) {
                set_tg_kontrol_mesaj("Bağlantı sorunu, kanal kontrolü yapılamadı.");
                return false;
            }
        }

        return true;
    };

    const verileri_isleyip_gonder = async (tiklama_olayi) => {
        tiklama_olayi.preventDefault();
        set_islem_suruyor_mu(true);
        set_hata_mesaji_metni("");
        set_donen_sonuclar(null);

        let uyelik_sarti_saglandi_mi = await tg_uyelikleri_denetle();
        if (!uyelik_sarti_saglandi_mi) {
            set_uyari_penceresi_acik_mi(true);
            set_islem_suruyor_mu(false);
            return;
        }

        try {
            const api_gelen_veri = await apiSorgu(tip, kullanici_girdileri);
            set_donen_sonuclar(api_gelen_veri);
        } catch (olusmus_hata) {
            set_hata_mesaji_metni(olusmus_hata.message || "Sorgu sunucu kısmında işlenemedi.");
        } finally {
            set_islem_suruyor_mu(false);
        }
    };

    const kutu_icerigi_degisti = (kutu_ismi, yeni_deger) => {
        set_kullanici_girdileri((mevcut_durum) => ({ ...mevcut_durum, [kutu_ismi]: yeni_deger }));
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <VuiBox py={3}>
                <VuiBox mb={3}>
                    <Card>
                        <VuiBox p={3}>
                            <VuiTypography variant="lg" color="white" fontWeight="bold" mb="5px">
                                {bulunan_aktif_sorgu.ad}
                            </VuiTypography>
                            <VuiTypography variant="button" color="text" fontWeight="regular">
                                İstenen verileri girip süreci başlatın.
                            </VuiTypography>
                            <VuiBox component="form" onSubmit={verileri_isleyip_gonder} mt={3}>
                                <Grid container spacing={2}>
                                    {bulunan_aktif_sorgu.alanlar.map((dng_alan) => (
                                        <Grid item xs={12} md={dng_alan.tip === "textarea" ? 12 : 6} key={dng_alan.ad}>
                                            <VuiBox mb={1} ml={0.5}>
                                                <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                    {dng_alan.etiket}
                                                </VuiTypography>
                                            </VuiBox>
                                            <GradientBorder
                                                minWidth="100%"
                                                padding="1px"
                                                borderRadius={borders.borderRadius.lg}
                                                backgroundImage={radialGradient(
                                                    palette.gradients.borderLight.main,
                                                    palette.gradients.borderLight.state,
                                                    palette.gradients.borderLight.angle
                                                )}
                                            >
                                                {dng_alan.tip === "textarea" ? (
                                                    <VuiInput
                                                        multiline
                                                        rows={4}
                                                        placeholder={dng_alan.etiket + " yazınız"}
                                                        value={kullanici_girdileri[dng_alan.ad] || ""}
                                                        onChange={(e_degisim) => kutu_icerigi_degisti(dng_alan.ad, e_degisim.target.value)}
                                                    />
                                                ) : (
                                                    <VuiInput
                                                        type="text"
                                                        placeholder={dng_alan.etiket + " yazınız"}
                                                        value={kullanici_girdileri[dng_alan.ad] || ""}
                                                        onChange={(e_degisim) => kutu_icerigi_degisti(dng_alan.ad, e_degisim.target.value)}
                                                    />
                                                )}
                                            </GradientBorder>
                                        </Grid>
                                    ))}
                                </Grid>
                                <VuiBox mt={3}>
                                    <VuiButton color="info" type="submit" disabled={islem_suruyor_mu}>
                                        {islem_suruyor_mu ? "KONTROL & SORGULAMA" : "SORGULAYI BAŞLAT"}
                                    </VuiButton>
                                </VuiBox>
                            </VuiBox>
                        </VuiBox>
                    </Card>
                </VuiBox>

                {hata_mesaji_metni && (
                    <VuiBox mb={3}>
                        <Card>
                            <VuiBox p={3}>
                                <VuiTypography variant="button" color="error" fontWeight="medium">
                                    {hata_mesaji_metni}
                                </VuiTypography>
                            </VuiBox>
                        </Card>
                    </VuiBox>
                )}

                {donen_sonuclar && <SonucTablo veri={donen_sonuclar} tip={tip} />}
            </VuiBox>
            <Footer />

            <Dialog
                open={uyari_penceresi_acik_mi}
                onClose={() => set_uyari_penceresi_acik_mi(false)}
                PaperProps={{
                    style: { backgroundColor: "#0f1535", color: "white", borderRadius: "15px", border: "1px solid #1a203f" }
                }}
            >
                <DialogTitle style={{ color: "#0075FF" }}>Erişim Reddedildi</DialogTitle>
                <DialogContent>
                    <VuiTypography variant="button" color="white">
                        {tg_kontrol_mesaj}
                    </VuiTypography>
                    <VuiBox display="flex" flexDirection="column" gap={2} mt={3}>
                        {_sart_kosulan_aglar.map((g_kanal, n_ind) => (
                            <VuiButton
                                key={n_ind}
                                component="a"
                                href={g_kanal.baglanti}
                                target="_blank"
                                rel="noreferrer"
                                color="info"
                                variant="contained"
                            >
                                {g_kanal.baslik} Kanalına Katıl
                            </VuiButton>
                        ))}
                    </VuiBox>
                </DialogContent>
                <DialogActions>
                    <VuiButton onClick={() => set_uyari_penceresi_acik_mi(false)} color="dark">
                        KAPAT
                    </VuiButton>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}

export default SorguPage;
